import { Component, Input, OnInit } from '@angular/core';
import { PlacementStudentV2 } from '../../_models';

@Component({
    selector: 'tutor-report-group',
    templateUrl: './tutor-report-group.component.html',
    styleUrls: ['./tutor-report-group.component.css'],
    standalone: false
})
export class TutorReportGroupComponent implements OnInit {
  @Input() includeContainerGutter: boolean = true;
  @Input() clientId: number;

  public selectedStudent: PlacementStudentV2;

  constructor() {}

  ngOnInit(): void {
      
  }

  public studentSelected(student: PlacementStudentV2): void {
    this.selectedStudent = student;
  }

  public showStudentList(): void {
    this.selectedStudent = null;
  }
}
